import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-4" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 1,
  class: "cursor-pointer text-muted",
  for: "more-filters-btn"
}
const _hoisted_5 = { class: "flex items-center w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons-outlined" }, " filter_alt_off ", -1)
const _hoisted_7 = {
  key: 1,
  class: "cursor-pointer text-muted",
  for: "remove-filters-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Chipset = _resolveComponent("Chipset")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TextInput, {
          modelValue: _ctx.modelValue.text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitUpdate('text', $event))),
          class: "flex-grow",
          searchBar: true,
          leftIcon: 'search',
          placeholder: _ctx.$t('filter_results.title')
        }, null, 8, ["modelValue", "placeholder"]),
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.full)
            ? (_openBlock(), _createBlock(_component_Btn, {
                key: 0,
                variant: 'icon',
                outline: true,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = !_ctx.expanded)),
                class: "",
                id: "more-filters-btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["transition-transform duration-200 ease-out transform material-icons-outlined", { 'rotate-180': _ctx.expanded }])
                  }, _toDisplayString(false && _ctx.expanded ? "expand_less" : "expand_more"), 3)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.full)
            ? (_openBlock(), _createElementBlock("label", _hoisted_4, _toDisplayString(_ctx.$t("filter_results.more_filters")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["mt-4 duration-200 ease-in-out md:mt-6 transition-max-height", {
					'max-h-100 overflow-auto': _ctx.full || _ctx.expanded,
					'max-h-0  overflow-y-hidden': !_ctx.full && !_ctx.expanded,
				}])
      }, [
        (_ctx.allowFilterByType)
          ? (_openBlock(), _createBlock(_component_Chipset, {
              key: 0,
              allowMultiple: false,
              options: _ctx.exerciseTypeOptions,
              modelValue: _ctx.modelValue.exercise_types,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitUpdate('exercise_types', $event)))
            }, null, 8, ["options", "modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.allowFilterByState)
          ? (_openBlock(), _createBlock(_component_Chipset, {
              key: 1,
              class: "my-2",
              allowMultiple: false,
              options: _ctx.exerciseStateOptions,
              modelValue: _ctx.modelValue.states,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitUpdate('states', $event)))
            }, null, 8, ["options", "modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Chipset, {
          options: _ctx.tagsOptions,
          modelValue: _ctx.modelValue.tags,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.emitUpdate('tags', $event)))
        }, null, 8, ["options", "modelValue"])
      ], 2),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.emptyFilters)
          ? (_openBlock(), _createBlock(_component_Btn, {
              key: 0,
              variant: 'icon',
              outline: true,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('resetFilters'))),
              class: "mr-0.5",
              id: "remove-filters-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.emptyFilters)
          ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(_ctx.$t("filter_results.remove_filters")), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}